import { mapValues, omit } from 'lodash';
/**
 * Version 16 migrations id confirmation widget
 * - move shared instruction text and header text to widget-level
 */
export default function v16(website) {
  return {
    ...website,
    eventVersion: 16,
    layoutItems: mapValues(website.layoutItems, layoutItem => {
      if (layoutItem.widgetType === 'EventIdentityConfirmation' &&
        !(layoutItem.config.instructionalText && layoutItem.config.headerText)) {
        return {
          ...layoutItem,
          config: {
            ...layoutItem.config,
            ...website.siteInfo.sharedConfigs.EventIdentityConfirmation
          }
        };
      }
      return layoutItem;
    }),
    siteInfo: {
      ...website.siteInfo,
      sharedConfigs: omit(website.siteInfo.sharedConfigs, ['EventIdentityConfirmation'])
    }
  };
}
